var map = {
	"./Administracion1.mp3": 708,
	"./Administracion2.mp3": 709,
	"./Administracion3.mp3": 710,
	"./Administracion4.mp3": 711,
	"./Administracion5.mp3": 712,
	"./Administracion6.mp3": 713,
	"./Administracion7.mp3": 714,
	"./admin3y4juntos.mp3": 715
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1066;


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios ^\.\/.*$
// module id = 1066
// module chunks = 1